const amountOfTaskClientFeedbacksOnPage = 20;

export default amountOfTaskClientFeedbacksOnPage;
